import React from 'react';
import { FundedLoansFollowUp } from './components/FundedLoansFollowUp';
export function App() {
  return <FundedLoansFollowUp data-id="element-0" />;
}